export const Illustrations: { [key: string]: any } = {
  illustration: require("./videoPaths.json"),
};
